import { createEntityAdapter } from '@reduxjs/toolkit';

export const coursesAdapter = createEntityAdapter({
    selectId: (x) => x.courseID,
});

export const userCoursesAdapter = createEntityAdapter({
    selectId: (x) => x.userCourseID,
});